import { usePropertiesLimit } from "./usePropertiesLimit";
export function useCanCreatePortfolio() {
  const {
    isPropertiesMaxed
  } = usePropertiesLimit();
  return !isPropertiesMaxed;
}